export function buildPreopenConfig({
                                       side,
                                       zerodhaUserId,

                                       quantity,
                                       amount,
                                       lastClosePrice,
                                       basePrice,

                                       preopenOrderDate,
                                       preopenPriceMode,
                                       customPreopenPrice,
                                       preopenTotalOrders,
                                       preopenRepeatTillDays,
                                       lotSize,
                                   }) {
    const qtyNum = quantity ? Number(quantity) : 0;
    const amountNum = amount ? Number(amount) : 0;
    const hasQty = qtyNum > 0;
    const hasAmount = amountNum > 0;

    if (!hasQty && !hasAmount) return { error: "For preopen orders, either quantity or amount is required." };
    if (hasQty && hasAmount) return { error: "Please use either quantity or amount, not both, for preopen orders." };
    if (!preopenOrderDate || !String(preopenOrderDate).trim())
        return { error: "Please select the date on which the preopen order should be placed." };

    const totalOrdersNum = Number(preopenTotalOrders);
    if (!Number.isFinite(totalOrdersNum) || totalOrdersNum <= 0) return { error: "Total number of preopen orders must be > 0." };

    const repeatDaysNum = (preopenRepeatTillDays === "" || preopenRepeatTillDays === null || preopenRepeatTillDays === undefined)
        ? null
        : Number(preopenRepeatTillDays);

    if (repeatDaysNum != null && (!Number.isFinite(repeatDaysNum) || repeatDaysNum < 0)) {
        return { error: "Repeat-till days must be ≥ 0 if specified." };
    }

    let effectivePrice = null;
    if (preopenPriceMode === "CUSTOM") {
        const p = Number(customPreopenPrice);
        if (!Number.isFinite(p) || p <= 0) return { error: "Custom preopen price must be > 0." };
        effectivePrice = p;
    }

    let finalQty = qtyNum;
    if (!hasQty && hasAmount) {
        const priceForQty = effectivePrice || lastClosePrice || basePrice;
        if (!priceForQty || priceForQty <= 0) return { error: "Unable to derive quantity – invalid price." };
        const derived = Math.floor(amountNum / priceForQty);
        if (!Number.isFinite(derived) || derived <= 0)
            return { error: "Amount is too small for the selected price, quantity becomes 0." };

// lot-aware flooring
        const lot = Number(lotSize);
        if (!Number.isFinite(lot) || lot <= 0)
            return { error: "Lot size is not available for this symbol. Cannot derive quantity from amount." };

        const lotAdjusted = Math.floor(derived / lot) * lot;

        if (lotAdjusted < lot) {
            return { error: `Amount is too small. Minimum is 1 lot (${lot}) at the selected price.` };
        }

        finalQty = lotAdjusted;

    }

    const lot = Number(lotSize);
    if (!Number.isFinite(lot) || lot <= 0) {
        return { error: "Lot size is not available for this symbol. Cannot place PREOPEN order." };
    }

    if (!Number.isFinite(finalQty) || finalQty <= 0) {
        return { error: "Quantity must be > 0." };
    }

    if (finalQty < lot) {
        return { error: `Quantity must be at least 1 lot (${lot}).` };
    }

// Strongly recommended for PREOPEN / F&O:
    if (finalQty % lot !== 0) {
        return { error: `Quantity must be a multiple of lot size (${lot}).` };
    }

    return {
        config: {
            side,
            mode: "PREOPEN",
            zerodhaUserId: zerodhaUserId || null,
            expectedQuantity: finalQty,
            preopen: {
                preopenOrderDate,
                preopenPriceMode,
                preopenCustomPrice: effectivePrice,
                preopenTotalOrders: totalOrdersNum,
                preopenRepeatTillDays: repeatDaysNum,
            }
        }
    };
}
